import { OfferIdContainer } from '../../containers/advancedFilters/OfferIdContainer';
import { IFilter } from '../../types/advancedFilters';

export const offerId: IFilter = {
  component: OfferIdContainer,
};
